/*
 * Inter, self-hosted and bundled rather than pulled from a font CDN.
 *
 * The typeface was named in the Tailwind config from the start but never
 * actually loaded, so every screen quietly fell back to the OS system font and
 * the `cv02/cv03/cv04` feature settings — which are Inter-specific character
 * variants — did nothing at all.
 *
 * Self-hosted because a distributor's back office may sit behind a corporate
 * proxy or run on a private network, and a blocked Google Fonts request would
 * mean the whole product renders in Times New Roman. It also keeps the app
 * free of a third-party request on every page load.
 *
 * The variable ("Variable") build carries every weight from 100 to 900 in one
 * file, which is smaller than the three static weights this UI uses.
 */
import '@fontsource-variable/inter';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
